import axiosServices from '@utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export async function fetchAnalysisItems(studyId) {
  const { data } = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/analyses/items`,
  );
  return data; // Array of { analysis_item_id, created_at, analysis_lens_type }
}
export async function fetchAnalysisItemDetail(studyId, analysisItemId) {
  const { data } = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/analyses/items/${analysisItemId}`,
  );
  return data; // AnalysisItemDetails, including optional results
}
export async function runAnalysisLens(
  studyId,
  analysis_lens_type,
  transcript_ids,
  analysis_level = null,
  custom_prompt = '',
  workspaceId = null,
  codebookOptions = null,
) {
  // workspace_id required for atomic credit deduction.
  //
  // ``codebookOptions`` carries the apply-codebook fields when the user
  // uploaded a structured codebook in the stepper. Optional + null for
  // the generate path. Shape:
  //   {
  //     custom_codes: [{name, definition?}],  // confirmed rows
  //     custom_context: string|null,
  //   }
  const url = `${backendUrl}/qualitative-studies/${studyId}/analyses/lenses/run${workspaceId ? `?workspace_id=${workspaceId}` : ''}`;
  const payload = {
    analysis_lens_type,
    transcript_ids,
    analysis_level,
    custom_prompt,
  };
  if (codebookOptions) {
    if (Array.isArray(codebookOptions.custom_codes) && codebookOptions.custom_codes.length > 0) {
      payload.custom_codes = codebookOptions.custom_codes;
    }
    if (codebookOptions.custom_context) {
      payload.custom_context = codebookOptions.custom_context;
    }
    if (codebookOptions.pause_for_review) {
      payload.pause_for_review = true;
    }
  }
  const { data } = await axiosServices.post(url, payload);
  return data;
}

export async function continuePausedAnalysis({ studyId, analysisItemId }) {
  // Resume a paused-for-review analysis. Server expects an empty body —
  // the analysis_item_id in the URL carries everything.
  const url = `${backendUrl}/qualitative-studies/${studyId}/analyses/${analysisItemId}/continue`;
  const { data } = await axiosServices.post(url);
  return data;
}
export async function deleteAnalysisItem({ studyId, analysisItemId }) {
  const url = `${backendUrl}/qualitative-studies/${studyId}/analyses/items/${analysisItemId}`;
  await axiosServices.delete(url);
}
export async function deleteChatHistoryItem({ chatId }) {
  const url = `${backendUrl}/chat/delete/${chatId}`;
  await axiosServices.delete(url);
}

export async function fetchNextAnalysis(studyId) {
  const { data } = await axiosServices.get(
    `${backendUrl}/qualitative-studies/studies/${studyId}/next_analysis_step`,
  );
  return data;
}
